import {functions, db, storage} from '@/scripts/firebase'
import {Unsubscribe,onSnapshot,writeBatch,collection,doc,where,query,documentId,serverTimestamp,DocumentData,DocumentReference,CollectionReference, Timestamp,QueryDocumentSnapshot,SnapshotOptions, orderBy, endAt, DocumentSnapshot, setDoc, getDoc} from 'firebase/firestore'
import {ref} from 'firebase/storage'
import { Component, Vue } from 'vue-property-decorator'
import * as Sentry from "@sentry/browser"
import { DateTime, IANAZone } from 'luxon'
import { ClassData, CreateAccountArg, CreateAccountRes, EventData, EventDocData, EventExtendedProps, GetParentsArg, GetParentsRes, GetUserRolesAccessLevelsArg, GetUserRolesAccessLevelsRes, GroupData, InvitationToken, MemberMeta, Playground, Playing,Sequence, ResetLineHookArg, ResetLineHookRes, SchedulingEntry, SchedulingSheet, SetUpLineHookArg, SetUpLineHookRes, UserNotifications} from '../common-datatypes'
import {VueTelInput} from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import Notice from "@/components/Notice.vue"
import { MessageBox, UserReceivedMessage, UserSentMessage } from '@/scripts/datatypes'
import { SentryError } from '@sentry/utils'
import { httpsCallable, HttpsCallableResult } from 'firebase/functions'
import { toHiragana, toZen } from 'jaconv'
import { $lineWebPageUrlOrigin, timeZoneNames } from '@/scripts/common'

@Component({
  components: {
    VueTelInput,
    Notice
  }
})

export default class Common extends Vue {
  created() {
    
    //
    //console.log(this.$timeZoneList)
  }

  get $typeList(){
    const x = [
      {
        type: 'event',
        icon: 'mdi-calendar-account-outline'
      },
      {
        type: 'scheduling',
        icon: 'mdi-calendar-question'
      },
      {
        type: 'playground',
        icon: 'mdi-seesaw'
      }
    ]
    return x
  }

  get $schoolLineWebPageUrl(){
    if(! this.$schoolLineAccountId){
      return ''
    }

    return $lineWebPageUrlOrigin + this.$schoolLineAccountId.replace('@','')
  }

  get $schoolLineAccountId(){
    if(! this.$store.state.school || ! this.$store.state.school.lineAccount){
      return ''
    }

    return (this.$store.state.school.lineAccount.premiumId || this.$store.state.school.lineAccount.basicId || '') as string
  }

  get $timeZoneList(){
    let names = timeZoneNames

    if(this.$defaultTimeZone){
      names.unshift(this.$defaultTimeZone)
      names = Array.from(new Set(names))
    }

    return names.map((tz) => {
      return {
        name: tz,
        offset: DateTime.local().setZone(tz).toFormat('ZZ')
      }
    })
  }

  get $defaultTimeZone(): string{
    return this.$store.getters.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  }

  $duration(d1: Date, d2?: Date){
    const dt1 = DateTime.fromJSDate(d1)
    const dt2 = d2 ? DateTime.fromJSDate(d2) : DateTime.now()
    const lang = this.$store.getters.lang
    const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
    const days = dt1.diff(dt2,'days').mapUnits((x) => {return Math.round(x)})
    return rtf.format(days.days, 'day')
  }

  $dateTimeFormat(date: Date | DateTime | Timestamp,format?: string, timeZone?: string,lang?: string ): string {
    const defaultTimeZone = this.$store.getters.timeZone as string
    const defaultLang = this.$store.getters.lang as string

    if(! date){
      return ''
    }

    let dt = ('isValid' in date && date.isValid) ? date : (('toDate' in date) ? DateTime.fromJSDate(date.toDate()) : DateTime.fromJSDate(date as Date))

    if(! dt.isValid){
      return ''
    }

    if(! timeZone || IANAZone.isValidZone(timeZone) === false){
      timeZone = defaultTimeZone
    }

    if(! lang ){
      lang = defaultLang
    }

    dt = dt.setLocale(lang).setZone(timeZone)

    if(format){
      return dt.toFormat(format)
    }

    const diffHours = dt.diffNow('hours').hours
    const diffMonths = dt.diffNow('months').months

    if(diffHours > 0){//未来
      if(diffMonths <= 1){
        return dt.toFormat('DDDD T (ZZZZ)').replace(/\d{4}[\D\S]/,'')
      }
    }else{//過去
      //24時間以内は時間のみ
      if(diffHours > -12){
        return dt.toFormat('T (ZZZZ)')
      }

      //半年以内は月・日
      if(diffMonths > -6){
        return dt.toFormat('DDDD T (ZZZZ)').replace(/\d{4}[\D\S]/,'')
      }
    }

    return dt.toFormat('DDDD T (ZZZZ)')
  }

  private addDocIdConverter = {
    toFirestore(data: DocumentData): DocumentData {
      return data
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
      const data = snapshot.data(options)
      return {
        ...data,
        docId: data.docId || snapshot.id
      }
    }
  }

  get $earlyAccess(){
    const earlyAccess = {
      messenger: false,
      scheduling: false,
      playground: false,
    }

    if(this.$store.state.school && this.$store.state.school.earlyAccess){
      const ea = this.$store.state.school.earlyAccess
      if(typeof ea === 'boolean'){
        earlyAccess.messenger = ea
        earlyAccess.playground = ea
        earlyAccess.scheduling = ea
      }else{
        if(ea.messenger){
          earlyAccess.messenger = !! ea.messenger
        }

        if(ea.scheduling){
          earlyAccess.scheduling = !! ea.scheduling
        }

        if(ea.playground){
          earlyAccess.playground = !! ea.playground
        }
      }
    }

    return earlyAccess
  }

  /*

  $n2br(text: string){
    if(text){
      return text.replace(/\n/g,'<br>')
    }
    return ''
  }

  */

  $dateToTime(date: Date){
    return date.getTime()
  }

  $timestampToDate(data: object){
    Object.keys(data).forEach((field) => {
      const f = field as keyof typeof data
      if(data[f] !== null && typeof data[f] === 'object' && 'toDate' in data[f]){
        const t = data[f] as Timestamp
        data[f] = t.toDate() as never
      }
    })
    return data
  }

  $getSchoolColRef(){
    const ref = collection(db,'schools/')
    return ref
  }

  $getSchoolDocRef(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = doc(this.$getSchoolColRef(),`${theSchoolId}`)
    return ref
  }

  $getSchoolPublicProfileColRef(){
    const ref = collection(db,'schoolPublicProfile')
    return ref
  }

  $getSchoolPublicProfileDocRef(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = doc(this.$getSchoolPublicProfileColRef(), theSchoolId)
    return ref
  }

  $getSchoolPrivateProfileColRef(){
    const ref = collection(db,'schoolPrivateProfile')
    return ref
  }

  $getSchoolPrivateProfileDocRef(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = doc(this.$getSchoolPrivateProfileColRef(), theSchoolId)
    return ref
  }

  $getUserPublicProfileColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId), 'userPublicProfile')
    return ref
  }

  $getUserPublicProfileDocRef(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = doc(this.$getUserPublicProfileColRef(schoolId), theUserId)
    return ref
  }

  $getUserNotificationsColRef(schoolId?: string) {
    const ref = collection(this.$getSchoolDocRef(schoolId),'userNotifications').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ): UserNotifications {
        const data = snapshot.data(options) as UserNotifications

        // add 2023-02-01
        if(data.messagesToChildren === undefined){
          data.messagesToChildren = true
        }

        return data
      }
    })
    return ref
  }
  
  $getUserNotificationsDocRef(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = doc(this.$getUserNotificationsColRef(schoolId),theUserId)
    return ref
  }

  $getUsersNotificationsQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = query(this.$getUserNotificationsColRef(theSchoolId),where('schoolId','==',theSchoolId))
    return ref
  }
  
  $getUserSettingsColRef(schoolId?: string) {
    const ref = collection(this.$getSchoolDocRef(schoolId),'userSettings')
    return ref
  }
  
  $getUserSettingsDocRef(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = doc(this.$getUserSettingsColRef(schoolId),theUserId)
    return ref
  }

  $getUsersSettingsQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = query(this.$getUserSettingsColRef(theSchoolId),where('schoolId','==',theSchoolId))
    return ref
  }

  $getUserPrivateProfileColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId), 'userPrivateProfile')
    return ref
  }

  $getUserPrivateProfileDocRef(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = doc(this.$getUserPrivateProfileColRef(schoolId),theUserId)
    return ref
  }

  $getUsersPublicProfileQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = query(this.$getUserPublicProfileColRef(theSchoolId),where('schoolId','==',theSchoolId),where('deleted','==',false))
    return ref
  }

  $getUsersPrivateProfileQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = query(this.$getUserPrivateProfileColRef(theSchoolId),where('schoolId','==',theSchoolId))
    return ref
  }

  $getUserRelationshipColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId), 'userRelationship')
    return ref
  }

  $getUserRelationshipDocRef(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = doc(this.$getUserRelationshipColRef(schoolId),theUserId)
    return ref
  }

  $getUsersRelationshipQuery(schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = query(this.$getUserRelationshipColRef(theSchoolId),where('schoolId','==',theSchoolId))
    return ref
  }

  $getUserSentMessageColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId),'userSentMessages').withConverter(this.addDocIdConverter).withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ): UserSentMessage {
        return snapshot.data(options) as UserSentMessage
      }
    })
    return ref
  }

  $getUserSentMessageDocRef(messageId?: string, schoolId?: string){
    const theMessageId = (messageId ? messageId : null)
    const ref = doc(this.$getUserSentMessageColRef(schoolId),`${theMessageId}`)
    return ref
  }

  $getUserReceivedMessageColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId),'userReceivedMessages').withConverter(this.addDocIdConverter).withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ): UserReceivedMessage {
        const data = snapshot.data(options) as UserReceivedMessage
        return data
      }
    })
    return ref
  }

  $getUserReceivedMessageDocRef(messageId?: string, schoolId?: string){
    const theMessageId = (messageId ? messageId : null)
    const ref = doc(this.$getUserReceivedMessageColRef(schoolId),`${theMessageId}`)
    return ref
  }

  $getReferenceObjectUserSentMessageQuery(referenceObjectIds: string[], schoolId?: string){
    const theReferenceObjectIds = referenceObjectIds
    const ref = query(this.$getUserSentMessageColRef(schoolId),where('referenceObjectIds', 'array-contains-any' , theReferenceObjectIds)).withConverter(this.addDocIdConverter)
    return ref
  }

  $getUserSentMessageQuery(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = query(this.$getUserSentMessageColRef(schoolId),where('senderUserId', '==' , theUserId)).withConverter(this.addDocIdConverter)
    return ref
  }

  $getUserReceivedMessageQuery(userId?: string | string[], schoolId?: string){
    const theUserId = (Array.isArray(userId) ? userId : (userId ? [userId] : [this.$store.getters.userId].concat(this.$store.getters.myChildren)))

    const ref = query(this.$getUserReceivedMessageColRef(schoolId),where('receiverUserIds','array-contains-any',theUserId)).withConverter(this.addDocIdConverter)
    return ref
  }

  $getUserSentReceivedMessageQuery(userId?: string, schoolId?: string){
    const theUserId = (userId ? userId : this.$store.getters.userId)
    const ref = query(this.$getUserReceivedMessageColRef(schoolId),where('senderUserId', '==' , theUserId)).withConverter(this.addDocIdConverter)
    return ref
  }

  $getReferenceObjectUserReceivedMessageQuery(referenceObjectIds: string[], schoolId?: string){
    const theReferenceObjectIds = referenceObjectIds
    const ref = query(this.$getUserReceivedMessageColRef(schoolId),where('referenceObjectIds', 'array-contains-any' , theReferenceObjectIds)).withConverter(this.addDocIdConverter)
    return ref
  }

  $getUserImagesRef(userId?: string, schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const theUserId = (userId ? userId : this.$store.getters.userId)

    const imagesRef = ref(storage,`/schools/${theSchoolId}/users/${theUserId}/images/`)
    
    return imagesRef
  }

  $getUserProfileImageRef(userId?: string, schoolId?: string){
    const profileRef = ref(storage, this.$getUserImagesRef(userId, schoolId).fullPath + '/profile')
    return profileRef
  }

  $getUserAudiosRef(userId?: string, schoolId?: string){
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const theUserId = (userId ? userId : this.$store.getters.userId)

    const audiosRef = ref(storage,`/schools/${theSchoolId}/users/${theUserId}/audios/`)
    
    return audiosRef
  }

  $getUserAudioRef(playingId: string, userId?: string, schoolId?: string){
    const audioFileRef = ref(storage, this.$getUserAudiosRef(userId, schoolId).fullPath + '/' + playingId)
    return audioFileRef
  }




  $getSchoolsPublicProfileQuery(schoolIds?: string[]){
    const theSchoolIds = (schoolIds ? schoolIds : Object.keys(this.$store.getters.schools))
    const ref = query(this.$getSchoolPublicProfileColRef(),where(documentId(), 'in', theSchoolIds),where('deleted','==',false))
    return ref
  }

  $getClassesColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId),'classes')
    return ref
  }

  $getUserClassesQuery(userId?: string | string[], schoolId?: string){
    const theUserId = (Array.isArray(userId) ? userId : (userId ? [userId] : [this.$store.getters.userId].concat(this.$store.getters.myChildren)))
    const ref = query(this.$getClassesColRef(schoolId),where('memberUserIds','array-contains-any',theUserId),where('deleted','==',false),where('disabled','==',false),where('postStatus','==','publish'))
    return ref
  }

  $getInvitationTokenColRef(){
    const ref = collection(db,'invitationToken')
    return ref
  }
  
  $getInvitationTokenQuery (value: string, field: keyof InvitationToken | string) {
    const ref = query(this.$getInvitationTokenColRef(),where(field,  '==' , value),orderBy('expirationTime','desc'),endAt(Timestamp.now()))
    return ref
  }
  
  $getInvitationTokenDocRef(tokenId: string){
    const theTokenId = (tokenId ? tokenId : '')
    const ref = doc(this.$getInvitationTokenColRef(),theTokenId)
    return ref
  }

  $getGroupsColRef(schoolId?: string){
    const ref = collection(this.$getSchoolDocRef(schoolId),'groups')
    return ref
  }

  $getUserGroupsQuery(userId?: string | string[], schoolId?: string){
    const theUserId = (Array.isArray(userId) ? userId : (userId ? [userId] : [this.$store.getters.userId].concat(this.$store.getters.myChildren)))
    const ref = query(this.$getGroupsColRef(schoolId),where('memberUserIds','array-contains-any',theUserId),where('deleted','==',false),where('disabled','==',false),where('postStatus','==','publish'))
    return ref
  }

  $getEventsColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const theSchoolId = (schoolId ? schoolId : this.$store.getters.schoolId)
    const ref = collection(db,`schools/${theSchoolId}/events/`).withConverter({
      toFirestore(data: EventData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ): EventData {
        const row = snapshot.data(options) as EventDocData
  
        const extendedProps = {
          ...row,
          docId: row.docId || snapshot.id,
        }
  
        Object.keys(extendedProps).forEach((prop) => {
          if(['start','end','title','id'].includes(prop)){
            delete extendedProps[prop as keyof EventExtendedProps]
          }
        })
  
        return {
          id: row.id || snapshot.id,
          title: row.title || '',
          start: row.start.toDate() || undefined,
          end: row.end.toDate() || undefined,
          timeZone: row.timeZone || '',
          editable: true,
          display: 'auto',
          extendedProps: timestampToDate(extendedProps) as EventExtendedProps
        }
      }
    })
    return ref
  }

  $getEventDocRef(eventDocId?: string, schoolId?: string){
    const theEventDocId = (eventDocId ? eventDocId : null)
    const ref = doc(this.$getEventsColRef(schoolId),`${theEventDocId}`)
    return ref
  }

  $getEventChangelogsColRef(eventDocId?: string, schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const theEventDocId = (eventDocId ? eventDocId : null)
    const ref = collection(doc(this.$getEventsColRef(schoolId),`${theEventDocId}`),'changelogs').withConverter({
      toFirestore(data: EventData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ): EventData {
        const row = snapshot.data(options) as EventDocData
  
        const extendedProps = {
          ...row,
          docId: row.docId || snapshot.id,
        }
  
        Object.keys(extendedProps).forEach((prop) => {
          if(['start','end','title','id'].includes(prop)){
            delete extendedProps[prop as keyof EventExtendedProps]
          }
        })
  
        return {
          id: row.id || snapshot.id,
          title: row.title || '',
          start: row.start.toDate() || undefined,
          end: row.end.toDate() || undefined,
          timeZone: row.timeZone || '',
          editable: true,
          display: 'auto',
          extendedProps: timestampToDate(extendedProps) as EventExtendedProps
        }
      }
    })
    return ref
  }

  $getUserEventsColRef(userId?: string | string[], schoolId?: string){
    const theUserId = (Array.isArray(userId) ? userId : (userId ? [userId] : [this.$store.getters.userId].concat(this.$store.getters.myChildren)))
    const ref = query(this.$getEventsColRef(schoolId),where('memberUserIds', 'array-contains-any', theUserId),where('postStatus', '==', 'publish'))
    return ref
  }

  $getPlaygroundColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const ref = collection(this.$getSchoolDocRef(schoolId),'playground').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
        let data = snapshot.data(options)

        data = timestampToDate(data)
 
        return data as Playground
      }
    })
    return ref
  }

  $getPlaygroundDocRef(playgroundId?: string, schoolId?: string){
    const thePlaygroundId = (playgroundId ? playgroundId : null)
    const ref = doc(this.$getPlaygroundColRef(schoolId),`${thePlaygroundId}`)
    return ref
  }

  $getPlayingColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const ref = collection(this.$getSchoolDocRef(schoolId),'playing').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
        let data = snapshot.data(options)

        data = timestampToDate(data)
        return data as Playing
      }
    })
    return ref
  }

  $getPlayingDocRef(playingId?: string, schoolId?: string){
    const thePlayingId = (playingId ? playingId : null)
    const ref = doc(this.$getPlayingColRef(schoolId),`${thePlayingId}`)
    return ref
  }

  $getSequencesColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const ref = collection(this.$getSchoolDocRef(schoolId),'sequences').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
        let data = snapshot.data(options)

        data = timestampToDate(data)
        return data as Sequence
      }
    })
    return ref
  }

  $getSequenceDocRef(sequenceId?: string, schoolId?: string){
    const theSequenceId = (sequenceId ? sequenceId : null)
    const ref = doc(this.$getSequencesColRef(schoolId),`${theSequenceId}`)
    return ref
  }

  $getSchedulingSheetsColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const ref = collection(this.$getSchoolDocRef(schoolId),'schedulingSheets').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
        let data = snapshot.data(options)

        data = timestampToDate(data)

        data.proposedDates = (data.proposedDates as SchedulingSheet['proposedDates']).map((proposedDate) => {
          return timestampToDate(proposedDate)
        })      
        return data as SchedulingSheet
      }
    })
    return ref
  }

  $getSchedulingSheetDocRef(schedulingSheetId?: string, schoolId?: string){
    const theSchedulingSheetId = (schedulingSheetId ? schedulingSheetId : null)
    const ref = doc(this.$getSchedulingSheetsColRef(schoolId),`${theSchedulingSheetId}`)
    return ref
  }

  $getSchedulingEntriesColRef(schoolId?: string){
    const timestampToDate = this.$timestampToDate
    const ref = collection(this.$getSchoolDocRef(schoolId),'schedulingEntries').withConverter({
      toFirestore(data: DocumentData): DocumentData {
        return data
      },
      fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions ) {
        let data = snapshot.data(options)

        data = timestampToDate(data)

        data.reply = (data.reply as SchedulingEntry['reply']).map((r) => {
          return timestampToDate(r)
        })
  
        return data as SchedulingEntry
      }
    })
    return ref
  }

  $getSchedulingEntryDocRef(schedulingEntryId?: string, schoolId?: string){
    const theSchedulingEntryId = (schedulingEntryId ? schedulingEntryId : null)
    const ref = doc(this.$getSchedulingEntriesColRef(schoolId),`${theSchedulingEntryId}`)
    return ref
  }

  $getSchedulingEntriesQuery(schedulingSheetId?: string, schoolId?: string){
    const theSchedulingSheetId = (schedulingSheetId ? schedulingSheetId : null)
    const ref = query(this.$getSchedulingEntriesColRef(schoolId),where('sheetId','==',theSchedulingSheetId),where('postStatus','in',['publish','draft']))
    return ref
  }

  $getUserSchedulingEntriesQuery(userId?: string | string[], schoolId?: string){
    const theUserId = (Array.isArray(userId) ? userId : (userId ? [userId] : [this.$store.getters.userId].concat(this.$store.getters.myChildren)))
    const ref = query(this.$getSchedulingEntriesColRef(schoolId),where('userId','in',theUserId))
    return ref
  }

  async $addDoc(colRef: CollectionReference, data: object){
    const creationTime = serverTimestamp()
    const docRef = doc(colRef)
    await setDoc(docRef, {
      ...data,
      docId: docRef.id,
      schoolId: this.$store.getters.schoolId || '',
      author: this.$store.getters.userId || '',
      updateTime: creationTime,
      creationTime: creationTime
    })
    return docRef
  }

  $updateDocs(docRefs: DocumentReference[], data: object[]){
    const batch = writeBatch(db)
    const docRef0 = docRefs[0]
    let changelogDocRef0: DocumentReference

    docRefs.forEach((docRef, index) => {
      console.log(data[index])
      const changelogDocRef = doc(collection(docRef, 'changelogs/'))
      if(index == 0){
        changelogDocRef0 = changelogDocRef
      }
      batch.set(changelogDocRef, {
        ...data[index],
        docId: docRef.id,
        schoolId: this.$store.getters.schoolId || '',
        author: this.$store.getters.userId || '',
        updateTime: serverTimestamp(),
        creationTime: serverTimestamp()
      })
    })

    return new Promise((resolve,reject) => {
      const unsubscribe = onSnapshot(docRef0, async(snapshot) => {
        try{
          console.log('updateDocs listener')
          const changelogDoc = await getDoc(changelogDocRef0)
          if(! changelogDoc.exists()){
            batch.commit()
          }else{
            const creationTime =  changelogDoc.get('creationTime')
            const updateTime: Timestamp = snapshot.get('updateTime')
            if(updateTime && creationTime && updateTime.toMillis() > creationTime.toMillis()) {
              unsubscribe()
              resolve(snapshot)
            }
          }
        }catch(error){
          unsubscribe()
          reject(error)
        }
      })
      window.setTimeout(() => {
        unsubscribe()
        reject(Error)
      },10000)
    }) as Promise<DocumentSnapshot>
  }

  $sleep(ms: number){
    return new Promise(resolve => setTimeout(resolve, ms))
  }


  $updateDoc(docRef: DocumentReference, data: object){
    const changelogDocRef = doc(collection(docRef, 'changelogs/'))

    const d = {
      ...data,
      docId: docRef.id,
      schoolId: this.$store.getters.schoolId || '',
      author: this.$store.getters.userId || '',
      updateTime: serverTimestamp(),
      creationTime: serverTimestamp()
    }

    return new Promise((resolve,reject) => {
      const unsubscribe = onSnapshot(docRef, async (snapshot) => {
        try{
          const updateTime = snapshot.get('updateTime')
          console.log('updateDoc listener')
          console.log(docRef.path)
          const changelogDoc = await getDoc(changelogDocRef)
          if(! changelogDoc.exists()){
            await setDoc(changelogDocRef, d)
          }else{
            const creationTime =  changelogDoc.get('creationTime')
            if(updateTime && creationTime && updateTime.toMillis() > creationTime.toMillis()) {
              unsubscribe()
              resolve(snapshot)
            }
          }
        }catch(error){
          unsubscribe()
          reject(error)
        }
      })

      window.setTimeout(() => {
        unsubscribe()
        reject(Error)

        new SentryError('doc timeout error.May not have the doc.')
      },180000)
    
    }) as Promise<DocumentSnapshot>
  }

  async $createDoc(colRef: CollectionReference, data: object){
    console.log(data)
    const docRef = doc(colRef)
    const docChangelogRef = doc(collection(docRef,'changelogs/'))

    const d1 = {
      docId: docRef.id,
      schoolId: this.$store.getters.schoolId || '',
      author: this.$store.getters.userId || '',
      updateTime: serverTimestamp(),
      creationTime: serverTimestamp()
    }

    const d2 = {
      ...data,
      ...d1
    }

    return new Promise((resolve,reject) => {
      let timer = 0
      const unsubscribe = onSnapshot(docRef,async(snapshot) => {
        try{
          console.log('createDoc listener')
          if(! snapshot.exists()){
            const batch = writeBatch(db)
            batch.set(docRef,d1).set(docChangelogRef, d2).commit()
          }else{
            const updateTime: Timestamp = snapshot.get('updateTime')
            const creationTime: Timestamp = snapshot.get('creationTime')
           
            if(updateTime && creationTime && updateTime.toMillis() > creationTime.toMillis()) {
              unsubscribe()
              resolve(snapshot)
              clearTimeout(timer)
            }
          }
        }catch(error){
          console.log(error)
          clearTimeout(timer)
          unsubscribe()
          reject(false)
        }
      })

      timer = window.setTimeout(() => {
        console.log('timeout')
        console.log(docRef.path)
        unsubscribe()
        reject(false)
      },180000)
      
    }) as (Promise<DocumentSnapshot> | Promise<false>)
  }
/*
  updateUser( input: FormInput): Promise < void > {
    // サイン イン 中 の ユーザー を 取得 
    const user = firebase.auth().currentUser
    return new Promise((resolve) => {
      // 更新 を 待機 する リスナ を 準備 
      const now = firebase.firestore.Timestamp.now()
      const unsubscribe = firebase.firestore().doc(` users/${ user. uid}`).onSnapshot((snapshot) => {
        // ドキュメント が 更新 さ れ たら 処理 を 完了 する 
        if (now < snapshot. get(' updatedAt'). toMillis() ) {
          unsubscribe()
          resolve()
        }
      })
      // 連絡 先 の 更新 ログ を 作成 
      firebase.firestore().collection(` users/${ user. uid}/ changelogs `).add({
        name: input.name,
        address: input.address,
        phoneNumber: input.phoneNumber,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      })
  }) 
}
*/
  

  $unsubscriber(observers: (Unsubscribe | undefined)[]){
    observers.map((observer: Unsubscribe | undefined) => {
      observer && observer()
    })
  }

  // eslint-disable-next-line 
  $getErrorCode(error: any){
  //  {"code":"functions/invalid-argument","name":"FirebaseError","details":{"message":"auth/email-already-in-use","status":"ALREADY_EXISTS"}}


    let code = ''
    code = (error && error.details && error.details.code) ? error.details.code : (error.code ? error.code : '') as string
    
    if(code.indexOf('functions/') > -1 && ( error.message || error.details.message)){
      code = error.message || error.details.message
    }

    if(code == 'permission-denied'){
      Sentry.captureException(error,(scope) => {
        scope.setUser({userId: this.$store.getters.userId});
        return scope
      })
    }
    return code as string
  }

  $getErrorMessageKey(code = '' , defaultMessagePath = ''){
    if(typeof code === 'string' && code !== '' && this.$te(`authentication.errorCode.${code}`)){
      return `authentication.errorCode.${code}`
    }

    if(typeof code === 'string' && code !== '' && this.$te(code)){
      return code
    }

    if(defaultMessagePath && this.$te(defaultMessagePath)){
      return defaultMessagePath
    }

    return 'message.error'
  }

  $getErrorField(code = ''){
    if(code.indexOf('email') > -1){
      return 'email'
    }

    if(code.indexOf('password') > -1){
      return 'password'
    }

    switch(code){
      case 'auth/user-mismatch':
      case 'auth/user-disabled':
      case 'auth/user-not-found':
      return 'email'
    }
    return ''
  }

  $findTextByMessage(text: string,message: MessageBox){
    const hiragana = toHiragana(toZen(text))
   
    const firstName = message.senderMeta.firstName || ''
    const lastName = message.senderMeta.lastName || ''
    const firstNameYomigana = message.senderMeta.firstNameYomigana || ''
    const lastNameYomigana = message.senderMeta.lastNameYomigana || ''
   
    const element = [
      firstName + lastName,
      lastName + firstName,
      firstNameYomigana + lastNameYomigana,
      lastNameYomigana + firstNameYomigana,
      firstName + lastNameYomigana,
      lastNameYomigana + firstName,
      firstNameYomigana + lastName,
      lastName + firstNameYomigana,
      message.body
    ]

    for(const objectId in message.referenceObjectMeta){
      const meta = message.referenceObjectMeta[objectId]
      element.push(
        meta.name
      )
    }

    for(const userId in message.receiverMeta){
      const meta = message.receiverMeta[userId]
      element.push(
        meta.firstName + meta.lastName,
        meta.lastName + meta.firstName,
        meta.firstNameYomigana + meta.lastNameYomigana,
        meta.lastNameYomigana + meta.firstNameYomigana,
        meta.firstName + meta.lastNameYomigana,
        meta.lastNameYomigana + meta.firstName,
        meta.firstNameYomigana + meta.lastName,
        meta.lastName + meta.firstNameYomigana
      )
    }


    return element.some((n) => {
      return n.indexOf(text) > -1 || toHiragana(toZen(n)).indexOf(hiragana) > -1
    })
  }

  $findTextByUserProfile(text: string,user: { familyMeta?: {[key: string]: MemberMeta}; phoneNumber?: string ; email?: string; firstName?: string; lastName?: string; firstNameYomigana?: string; lastNameYomigana?: string }){
    
    const hiragana = toHiragana(toZen(text))

    const firstName = user.firstName || ''
    const lastName = user.lastName || ''
    const firstNameYomigana = user.firstNameYomigana || ''
    const lastNameYomigana = user.lastNameYomigana || ''
    const phoneNumber = user.phoneNumber || ''
    const email = user.email || ''
   
    const element = [
      firstName + lastName,
      lastName + firstName,
      firstNameYomigana + lastNameYomigana,
      lastNameYomigana + firstNameYomigana,
      firstName + lastNameYomigana,
      lastNameYomigana + firstName,
      firstNameYomigana + lastName,
      lastName + firstNameYomigana,
      phoneNumber,
      email
    ]

    for(const userId in user.familyMeta){
      const meta = user.familyMeta[userId]
      element.push(
        meta.firstName + meta.lastName,
        meta.lastName + meta.firstName,
        meta.firstNameYomigana + meta.lastNameYomigana,
        meta.lastNameYomigana + meta.firstNameYomigana,
        meta.firstName + meta.lastNameYomigana,
        meta.lastNameYomigana + meta.firstName,
        meta.firstNameYomigana + meta.lastName,
        meta.lastName + meta.firstNameYomigana
      )
    }


    return element.some((n) => {
      return n.indexOf(text) > -1 || toHiragana(toZen(n)).indexOf(hiragana) > -1
    })
  }

  $findTextByEvent(text: string,event: EventData){
    const hiragana = toHiragana(toZen(text))

    const className = event.extendedProps.className || ''
    const groupName = event.extendedProps.groupName || ''
    const note = event.extendedProps.note || ''
    const title = event.title || ''
    const element = [
      className,
      groupName,
      note,
      title
    ]

    return element.some((n) => {
      return n.indexOf(text) > -1 || toHiragana(toZen(n)).indexOf(hiragana) > -1
    })
  }

  $getReferenceObjectName(data: EventData | ClassData | GroupData | SchedulingSheet | Playground, type: 'event' | 'scheduling' | 'playground'){
    let name = ''
    switch(type){
      case 'event': {
        const eventData = data as EventData
        name = eventData.title || ''
        name += (eventData.extendedProps.groupName ? ' ' + eventData.extendedProps.groupName : '')
        name += (eventData.extendedProps.className ? ' ' + eventData.extendedProps.className : '')
        break
      }
      case 'scheduling':
      default:
        //title プロパティあるかどうか
        if('title' in data){
          name = data.title || ''
        }
        break
    }
    return name
  }

  $trimStringWidth(text: string, width: number, marker = '...'){
    const length = text.length
    if(length <= width){
      return text
    }
    const finalWidth = (width - marker.length > 0 ) ? width - marker.length : 0
    return text.substring(0,finalWidth) + marker
  }

  $stripTags(html: string){
    const tmp = document.createElement("DIV")
    tmp.innerHTML = html || ''
    return tmp.textContent || ""
  }

  $autoLink(text: string){
    return text.replace(/(https?:\/\/[\w/:%#$&?()~.=+-]+)/g, "<span class='icon'><i class='mdi mdi-link'></i></span><a href='$1'>$1</a>")
  }

  $eventObjectToEventDocData(event: EventData): EventDocData{
    const extendedProps = {...event.extendedProps}
    const d = {
      ...extendedProps,
      id: event.id || '',
      title: event.title || '',
      start: Timestamp.fromDate(event.start),
      end: Timestamp.fromDate(event.end),
      timeZone: event.timeZone
    }
    console.log(d)
    return d
  }

  $getParents(data: GetParentsArg){
    const http = httpsCallable(functions,'getParents')
    const result = http(data) as Promise<HttpsCallableResult<GetParentsRes>>
    return result
  }

  $createAccount(data: CreateAccountArg){
    const http = httpsCallable(functions,'createAccount')
    const result = http(data) as Promise<HttpsCallableResult<CreateAccountRes>>
    return result
  }

  $setUpLineHook(data: SetUpLineHookArg){
    const http = httpsCallable(functions,'setUpLineHook')
    const result = http(data) as Promise<HttpsCallableResult<SetUpLineHookRes>>
    return result
  }

  $resetLineHook(data: ResetLineHookArg){
    const http = httpsCallable(functions,'resetLineHook')
    const result = http(data) as Promise<HttpsCallableResult<ResetLineHookRes>>
    return result
  }


  $getUserRolesAccessLevels(schoolId: string){
    const http = httpsCallable(functions,'getUserRolesAccessLevels')
    const result = http({schoolId: schoolId} as GetUserRolesAccessLevelsArg) as Promise<HttpsCallableResult<GetUserRolesAccessLevelsRes>>
    return result
  }

  $getMessageIconClass(status: string){
    const table = {
      'mdi-check-circle': 'read',
      'mdi-check-circle-outline': 'unread',
      'mdi-thumb-up': 'like',
      'mdi-thumb-up-outline': 'unlike'
    }

    for(const key in table){
      if(table[key as keyof typeof table] == status){
        return {
          [key]: true
        }
      }
    }
    return {}
  }


  //https://firebase.google.com/docs/reference/js/firebase.User?hl=en#error-codes_13
/*
auth/invalid-email
Thrown if the email used is invalid.
auth/email-already-in-use
Thrown if the email is already used by another user.
auth/requires-recent-signIn
Thrown if the user's last sign-in time does not meet the security threshold. Use firebase.User.reauthenticateWithCredential to resolve. This does not apply if the user is anonymous.
*/

//https://firebase.google.com/docs/reference/js/firebase.User?hl=en#error-codes_7
/*
auth/user-mismatch
Thrown if the credential given does not correspond to the user.
auth/user-not-found
Thrown if the credential given does not correspond to any existing user.
auth/invalid-credential
Thrown if the provider's credential is not valid. This can happen if it has already expired when calling link, or if it used invalid token(s). See the Firebase documentation for your provider, and make sure you pass in the correct parameters to the credential method.
auth/invalid-email
Thrown if the email used in a firebase.auth.EmailAuthProvider.credential is invalid.
auth/wrong-password
Thrown if the password used in a firebase.auth.EmailAuthProvider.credential is not correct or when the user associated with the email does not have a password.
auth/invalid-verification-code
Thrown if the credential is a firebase.auth.PhoneAuthProvider.credential and the verification code of the credential is not valid.
auth/invalid-verification-id
Thrown if the credential is a firebase.auth.PhoneAuthProvider.credential and the verification ID of the credential is not valid.
*/
}

